module.exports = __webpack_public_path__ + "static/media/group-working.b6c2b63e.jpg";